/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "store/actions/auth";
import Constants from "app_constants";
import Theme from "./theme";

import logo from "assets/img/logo.png";

const renderCategories = (goTo) => {
  const jobCategories = Constants.jobCategories;
  const result = [];
  let index = 0;

  for (const key in jobCategories) {
    result.push(
      <a
        key={index}
        className="navbar-item"
        onClick={() => goTo(`/category/${key}`)}
      >
        {jobCategories[key]}
      </a>
    );
    index++;
  }

  return result;
};

const Header = (props) => {
  const { history, user, logout } = props;
  const [mobileMenu, setMobileMenu] = useState(false);

  const goTo = (route) => {
    window.scrollTo(0, 0);
    setMobileMenu(false);
    history.push(route);
  };

  return (
    <Theme>
      <nav
        className="navbar is-transparent"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="navbar-brand">
          <a className="navbar-item">
            <img src={logo} onClick={() => goTo("/")} className="logo" />
          </a>
          <a
            onClick={() => setMobileMenu(!mobileMenu)}
            role="button"
            className={`navbar-burger burger${mobileMenu ? " is-active" : ""}`}
            aria-label="menu"
            aria-expanded="false"
            data-target="navbarBasicExample"
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </a>
        </div>
        <div className={`navbar-menu${mobileMenu ? " is-active" : ""}`}>
          <div className="navbar-start">
            <a onClick={() => goTo("/")} className="navbar-item">
              Home
            </a>
            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link">Job Categories</a>
              <div className="navbar-dropdown is-boxed">
                {renderCategories(goTo)}
              </div>
            </div>
            <a
              onClick={() => goTo("/resources")}
              target="_blank"
              className="navbar-item"
            >
              Resources
            </a>
            <a onClick={() => goTo("/pricing")} className="navbar-item">
              Pricing
            </a>
            <a onClick={() => goTo("/contact")} className="navbar-item">
              Contact
            </a>
            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link" href="#">
                More
              </a>
              <div className="navbar-dropdown is-boxed">
                <a onClick={() => goTo("/about")} className="navbar-item">
                  About
                </a>
                <a onClick={() => goTo("/contact")} className="navbar-item">
                  Collaboration
                </a>
                <a
                  onClick={() => goTo("/terms-conditions")}
                  className="navbar-item"
                >
                  Terms & Conditions
                </a>
                <a
                  onClick={() => goTo("/privacy-policy")}
                  className="navbar-item"
                >
                  Privacy Policy
                </a>
                <a onClick={() => goTo("/faq")} className="navbar-item">
                  FAQ
                </a>
                <hr className="navbar-divider" />
                <a onClick={() => goTo("/contact")} className="navbar-item">
                  Report an issue
                </a>
              </div>
            </div>
          </div>
          <div className="navbar-end">
            <div className="navbar-item">
              <div className="buttons">
                {!user.id && !user.type ? (
                  <Fragment>
                    <a
                      onClick={() => goTo("/register")}
                      className="button is-primary"
                    >
                      <strong>Sign up</strong>
                    </a>
                    <a
                      onClick={() => goTo("/login")}
                      className="button is-light"
                    >
                      Login
                    </a>
                  </Fragment>
                ) : user.type === "company" ? (
                  <Fragment>
                    <a
                      onClick={() => goTo("/publish-job")}
                      className="button is-primary"
                    >
                      Publish Job
                    </a>
                    <a
                      onClick={() => {
                        window.scrollTo(0, 0);
                        setMobileMenu(false);
                        logout();
                      }}
                      className="button is-light"
                    >
                      Logout
                    </a>
                  </Fragment>
                ) : (
                  <a
                    onClick={() => {
                      window.scrollTo(0, 0);
                      setMobileMenu(false);
                      logout();
                    }}
                    className="button is-primary"
                  >
                    Logout
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </Theme>
  );
};

const mapStateToProps = ({ user }) => ({
  user,
});

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
